import script from "./StageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StageItem.vue?vue&type=script&setup=true&lang=js"

import "./StageItem.vue?vue&type=style&index=0&id=122725f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122725f6"]])

export default __exports__